import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from 'shared';
import {BreedsComponent} from './breeds.component';
import {BreedFormComponent} from './breed-form/breed-form.component';

@NgModule({
  declarations: [
    BreedsComponent,
    BreedFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: BreedsComponent
      }
    ])
  ]
})
export class BreedsModule {
}
